if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();

        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      get quantity() {
        return this.querySelector('quantity-input');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get select() {
        return this.querySelector('select');
      }

      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector(
          `.main-product-form[data-product-id="${this.productId}"]`
        );

        this.mainProductInfo = document.querySelector(
          `product-info[data-product-id="${this.productId}"]`
        );

        this.container = this.closest('.sticky-atc-bar');

        // Important:
        // Target only the sticky Add to Cart button.
        // Dynamic checkout / Buy It Now is handled separately.
        this.submitButton = this.querySelector('[name="add"]');


this.dynamicCheckoutButton = this.querySelector(
  '.shopify-payment-button__button'
);

if (this.dynamicCheckoutButton && this.productFormActions) {
  this.dynamicCheckoutButton.addEventListener(
    'click',
    (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();

      const mainDynamicCheckoutButton = this.productFormActions.querySelector(
        '.shopify-payment-button__button'
      );

      if (!mainDynamicCheckoutButton) {
        console.warn(
          'Sticky ATC: Main Buy It Now button not found.'
        );
        return;
      }

      // Sync variant
      const stickyVariantInput = this.querySelector('[name="id"]');
      const mainVariantInput =
        this.productFormActions.querySelector('[name="id"]');

      if (stickyVariantInput && mainVariantInput) {
        mainVariantInput.value = stickyVariantInput.value;

        mainVariantInput.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      }

      // Sync quantity
      const stickyQuantity = this.quantityInput;
      const mainQuantity =
        this.productFormActions.querySelector('[name="quantity"]');

      if (stickyQuantity && mainQuantity) {
        mainQuantity.value = stickyQuantity.value;

        mainQuantity.dispatchEvent(
          new Event('change', {
            bubbles: true,
          })
        );
      }

      // Trigger MAIN PDP Buy It Now
      mainDynamicCheckoutButton.click();
    },
    true
  );
}



        const variantInput = this.querySelector(
          this.selectors.variantIdSelect
        );

        this.selectedVariantId = variantInput
          ? variantInput.value
          : null;

        this.variantData = this.getVariantData();

        this.init();

        /*
         * ------------------------------------------------------------
         * STICKY VARIANT CHANGE
         * ------------------------------------------------------------
         */

        if (this.select) {
          this.select.addEventListener('change', (e) => {
            if (this.isUpdating) return;

            this.isUpdating = true;

            const selectedVariantId = this.querySelector(
              this.selectors.variantIdSelect
            ).value;

            this.selectedVariantId = selectedVariantId;

            this.currentVariant = this.variantData.find(
              (variant) =>
                variant.id === Number(selectedVariantId)
            );

            this.updateQuantityInput();

            this.mainVariantSelects =
              this.mainProductInfo &&
              this.mainProductInfo.querySelector('variant-selects');

            /*
             * Synchronize sticky variant selection
             * with the main PDP variant picker.
             */
            if (this.mainVariantSelects && this.currentVariant) {
              Array.from(
                this.mainVariantSelects.querySelectorAll(
                  'select, fieldset'
                )
              ).forEach((element, index) => {
                const variantOptionVal =
                  this.currentVariant.options[index];

                switch (element.tagName) {
                  case 'SELECT': {
                    element.value = variantOptionVal;

                    const options =
                      element.querySelectorAll('option');

                    options.forEach((option) =>
                      option.removeAttribute('selected')
                    );

                    const selectedOption =
                      element.querySelector(
                        `option[value="${CSS.escape(
                          variantOptionVal
                        )}"]`
                      );

                    if (selectedOption) {
                      selectedOption.setAttribute(
                        'selected',
                        'selected'
                      );
                    }

                    break;
                  }

                  case 'FIELDSET': {
                    Array.from(
                      element.querySelectorAll('input')
                    ).forEach((radio) => {
                      if (radio.value === variantOptionVal) {
                        radio.checked = true;
                      }
                    });

                    break;
                  }
                }
              });

              setTimeout(() => {
                /*
                 * Keep the original FoxTheme behavior.
                 */
                this.mainVariantSelects.dispatchEvent(
                  new Event('change', {
                    bubbles: true,
                  })
                );

                this.isUpdating = false;
              }, 0);
            } else {
              this.isUpdating = false;
            }

            this.updatePrice();

            this.updateButton(true, '', false);

            if (!this.currentVariant) {
              this.updateButton(true, '', true);
            } else {
              this.updateButton(
                !this.currentVariant.available,
                FoxTheme.variantStrings.soldOut
              );
            }
          });
        }

        /*
         * ------------------------------------------------------------
         * STICKY ADD TO CART → MAIN PDP FORM
         * ------------------------------------------------------------
         *
         * DO NOT submit the sticky form directly.
         *
         * Easify attaches its customization / line-item properties
         * to the main PDP product form.
         *
         * Therefore we synchronize variant + quantity and submit
         * the main form instead.
         */

        if (this.submitButton && this.productFormActions) {
          this.submitButton.addEventListener(
            'click',
            (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();

              /*
               * Sticky variant
               */
              const stickyVariantInput =
                this.querySelector('[name="id"]');

              /*
               * Main PDP variant
               */
              const mainVariantInput =
                this.productFormActions.querySelector(
                  '[name="id"]'
                );

              if (
                stickyVariantInput &&
                mainVariantInput &&
                stickyVariantInput.value
              ) {
                mainVariantInput.value =
                  stickyVariantInput.value;

                mainVariantInput.dispatchEvent(
                  new Event('change', {
                    bubbles: true,
                  })
                );
              }

              /*
               * Synchronize quantity.
               */
              const stickyQuantity =
                this.quantityInput;

              const mainQuantity =
                this.productFormActions.querySelector(
                  '[name="quantity"]'
                );

              if (stickyQuantity && mainQuantity) {
                mainQuantity.value =
                  stickyQuantity.value;

                mainQuantity.dispatchEvent(
                  new Event('change', {
                    bubbles: true,
                  })
                );
              }

              /*
               * Submit MAIN PDP form.
               *
               * Easify should now be able to process its
               * customization fields / line-item properties.
               */
              this.productFormActions.requestSubmit();
            },
            true
          );
        }
      }

      /*
       * ------------------------------------------------------------
       * UPDATE QUANTITY
       * ------------------------------------------------------------
       */

      updateQuantityInput() {
        const variantInput = this.querySelector(
          this.selectors.variantIdSelect
        );

        if (!variantInput) return;

        this.selectedVariantId = variantInput.value;

        this.currentVariant = this.variantData.find(
          (variant) =>
            variant.id === Number(this.selectedVariantId)
        );

        if (!this.currentVariant) return;

        fetch(
          `${this.getAttribute(
            'data-url'
          )}?variant=${
            this.currentVariant.id
          }&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML =
              new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

            const quantity = document.querySelector(
              `#QuantitySticky-${this.sectionId}`
            );

            const newQuantity =
              parsedHTML.querySelector(
                `#QuantitySticky-${this.sectionId}`
              );

            if (quantity && newQuantity) {
              quantity.innerHTML =
                newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }

      /*
       * ------------------------------------------------------------
       * VARIANT DATA
       * ------------------------------------------------------------
       */

      getVariantData() {
        if (this.variantData) {
          return this.variantData;
        }

        const json =
          this.container &&
          this.container.querySelector(
            '[type="application/json"]'
          );

        if (!json) {
          return [];
        }

        try {
          this.variantData = JSON.parse(
            json.textContent
          );
        } catch (error) {
          console.error(
            'Sticky ATC: unable to parse variant data.',
            error
          );

          this.variantData = [];
        }

        return this.variantData;
      }

      /*
       * ------------------------------------------------------------
       * INITIALIZATION
       * ------------------------------------------------------------
       */

      init() {
        if (!this.productFormActions) {
          this.container.classList.add(
            'sticky-atc-bar--show'
          );

          return;
        }

        const mql = window.matchMedia(
          FoxTheme.config.mediaQueryMobile
        );

        mql.onchange =
          this.checkDevice.bind(this);

        this.checkDevice();

        const rootMargin =
          '-80px 0px 0px 0px';

        this.observer =
          new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                const method =
                  entry.intersectionRatio !== 1
                    ? 'add'
                    : 'remove';

                this.container.classList[method](
                  'sticky-atc-bar--show'
                );
              });
            },
            {
              threshold: 1,
              rootMargin,
            }
          );

        this.setObserveTarget();

        this.syncWithMainProductForm();
      }

      /*
       * ------------------------------------------------------------
       * OBSERVER
       * ------------------------------------------------------------
       */

      setObserveTarget() {
        if (
          !this.observer ||
          !this.productFormActions
        ) {
          return;
        }

        this.observer.observe(
          this.productFormActions
        );

        this.observeTarget =
          this.productFormActions;
      }

      /*
       * ------------------------------------------------------------
       * DEVICE
       * ------------------------------------------------------------
       */

      checkDevice() {
        document.documentElement.style.setProperty(
          '--sticky-atc-bar-height',
          `${this.clientHeight}px`
        );
      }

      /*
       * ------------------------------------------------------------
       * BUTTON STATE
       * ------------------------------------------------------------
       */

      updateButton(
        disable = true,
        text,
        modifyClass = true
      ) {
        const productForm =
          this.querySelector(
            'form[is="product-form"]'
          );

        if (!productForm) return;

        const addButton =
          productForm.querySelector(
            '[name="add"]'
          );

        if (!addButton) return;

        const addButtonText =
          addButton.querySelector('span');

        if (disable) {
          addButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text && addButtonText) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute(
            'disabled'
          );

          if (addButtonText) {
            addButtonText.textContent =
              FoxTheme.variantStrings.addToCart;
          }
        }
      }

      /*
       * ------------------------------------------------------------
       * PRICE
       * ------------------------------------------------------------
       */

      updatePrice() {
        if (!this.currentVariant) return;

        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };

        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: [
            '.f-price-item--regular',
          ],
          unitPriceWrapper:
            '.f-price__unit-wrapper',
        };

        const moneyFormat =
          FoxTheme.settings.moneyFormat;

        const {
          priceWrapper,
          salePrice,
          unitPriceWrapper,
          compareAtPrice,
        } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );

        const unitPrice =
          unitPriceWrapper &&
          unitPriceWrapper.querySelector(
            '.f-price__unit'
          );

        const {
          compare_at_price,
          price,
          unit_price_measurement,
        } = this.currentVariant;

        /*
         * On sale
         */
        if (
          compare_at_price &&
          compare_at_price > price
        ) {
          priceWrapper.classList.add(
            classes.onSale
          );
        } else {
          priceWrapper.classList.remove(
            classes.onSale
          );
        }

        /*
         * Sold out
         */
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(
            classes.soldOut
          );
        } else {
          priceWrapper.classList.remove(
            classes.soldOut
          );
        }

        if (salePrice) {
          salePrice.innerHTML =
            FoxTheme.Currency.formatMoney(
              price,
              moneyFormat
            );
        }

        if (
          compareAtPrice &&
          compareAtPrice.length &&
          compare_at_price > price
        ) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML =
                FoxTheme.Currency.formatMoney(
                  compare_at_price,
                  moneyFormat
                ))
          );
        } else if (compareAtPrice) {
          compareAtPrice.forEach(
            (item) =>
              (item.innerHTML =
                FoxTheme.Currency.formatMoney(
                  price,
                  moneyFormat
                ))
          );
        }

        if (
          unit_price_measurement &&
          unitPrice &&
          unitPriceWrapper
        ) {
          unitPriceWrapper.classList.remove(
            'hidden'
          );

          unitPrice.innerHTML = `
            <span>
              ${FoxTheme.Currency.formatMoney(
                this.currentVariant.unit_price,
                moneyFormat
              )}
            </span>
            /
            <span data-unit-price-base-unit>
              ${FoxTheme.Currency.getBaseUnit(
                this.currentVariant
              )}
            </span>
          `;
        } else if (unitPriceWrapper) {
          unitPriceWrapper.classList.add(
            'hidden'
          );
        }
      }

      /*
       * ------------------------------------------------------------
       * MAIN PDP → STICKY BAR SYNC
       * ------------------------------------------------------------
       */

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS
            .variantChange,
          (event) => {
            if (
              !this.mainProductInfo ||
              !event ||
              !event.data
            ) {
              return;
            }

            const isMainProduct =
              event.data.sectionId ===
              this.mainProductInfo.dataset.section;

            if (!isMainProduct) return;

            const variant =
              event.data.variant;

            const variantInput =
              this.querySelector('[name="id"]');

            this.currentVariant = variant;

            if (variantInput && variant) {
              variantInput.value = variant.id;
              this.selectedVariantId =
                variant.id;
            }

            this.updatePrice();

            this.updateButton(
              true,
              '',
              false
            );

            if (!variant) {
              this.updateButton(
                true,
                '',
                true
              );
            } else {
              this.updateButton(
                !variant.available,
                FoxTheme.variantStrings.soldOut
              );
            }

            this.updateQuantityInput();
          }
        );
      }
    }
  );
}